import type { Locale } from './typeHelper'
import type { Advisor } from '@/.generated/tbfTypes/graphql'
import VCard from 'vcard-creator'

const generateVCard = (
  { lastName, firstName, roles, phone, email }: Advisor,
  locale: Locale,
) => {
  const vCard = new VCard()
  const roleCombined: string =
    roles!.map((role) => role?.[locale]).join(', ') ?? ''

  vCard
    .addName(lastName ?? '', firstName ?? '')
    .addCompany('TBF + Partner AG')
    .addJobtitle(roleCombined)
    .addEmail(email ?? '')
    .addPhoneNumber(phone ?? '', 'PREF;WORK')
    .addURL('https://www.tbf.ch')

  return vCard.toString()
}

export const downloadVCard = (props: Advisor, locale: Locale) => {
  const vCardString = generateVCard(props, locale)
  const filename = 'vCard.vcf'
  const blob = new Blob([vCardString], { type: 'text/csv' })
  const navigator: any = window.navigator
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, filename)
  } else {
    const elem = window.document.createElement('a')
    const vcardUrl = window.URL.createObjectURL(blob)
    elem.href = vcardUrl
    elem.download = filename
    document.body.appendChild(elem)
    elem.click()
    document.body.removeChild(elem)

    setTimeout(() => {
      window.URL.revokeObjectURL(vcardUrl)
    }, 10000) // 10 seconds
  }
}
